<template>
  <TwinPanel title="Reset your password">
    <template v-slot:form>
      <div v-show="success">
        <p>
          We’ve emailed you instructions for setting your password, if an account exists with the email you
          entered. You should receive them shortly.
        </p>

        <p>
          If you don’t receive an email, please make sure you’ve entered the address you registered with, and
          check
          your spam folder.
        </p>

        <p><strong>Still having trouble?</strong></p>
        <p>Email support at <a href="mailto:team@heurix.io">team@heurix.io</a></p>
      </div>
      <b-form v-show="!success" :novalidate="true" class="form" @submit="onSubmit">
        <b-alert variant="danger" :show="error">
          {{ error }}
        </b-alert>

        <b-form-group label="Email" label-for="userEmail">
          <b-form-input
            id="userEmail"
            v-model="user.email"
            debounce="350"
            required
            :state="emailValid"
          />
          <b-form-invalid-feedback :state="emailValid">
            This doesn't look like an email to me...
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button type="submit" variant="primary"
                  :pressed="submitting"
                  :disabled="submitting || !emailValid ">
          Reset your password
        </b-button>
      </b-form>
    </template>
    <template v-slot:text>
      <h4>Oops, don't worry, we'll have you back evaluating in a flash.</h4>
    </template>
  </TwinPanel>
</template>


<style lang="scss" scoped>
    .form {
        margin: 0 auto;
        max-width: 550px;

        input, button {
            height: 3em;
            width: 100%;
        }

        button:disabled, button {
            background-color: #ff583b;
            border-color: #ff583b;
        }
    }
</style>

<script>
    import isEmail from 'validator/lib/isEmail'
    import apiMixin from "../../utils/api"
    import TwinPanel from "./utils/TwinPanel"

    export default {
        name: 'UserRegister',
        components: {TwinPanel},
        mixins: [apiMixin],
        data() {
            return {
                user: {},
                error: null,
                submitting: false,
                success: false
            }
        },
        computed: {
            emailValid() {
                if (!this.user.email) {
                    return null
                }
                return isEmail(this.user.email)
            }
        },
        async created() {
            let maybeReroute = val => {
                if (val) {
                    this.navigate('site.list')
                }
            }
            this.$store.watch(
                (state, getters) => getters['user/loggedIn'],
                (newValue) => {
                    maybeReroute(newValue)
                },
            )
            maybeReroute(this.$store.getters['user/loggedIn'])
        },
        methods: {
            async onSubmit(e) {
                e.preventDefault()
                this.withLoading(async () => {
                    try {
                        await this.post("/api/users/reset-token/", this.user)
                        this.success = true
                    } catch (e) {
                        this.error = e.error
                    }
                }, 'submitting')
            }
        }
    }
</script>
